import React from 'react';
import { Link } from 'react-router-dom';
import type { FooterProps } from './navigation.types';
import './Navigation.styles.css';

// * Verified real contact address as required by DPDP / legal compliance
const VERIFIED_ADDRESS = 'Jaipur, Rajasthan 302001, India';

export const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  const currentYear = new Date().getFullYear();

  const handleOpenCookieSettings = (): void => {
    window.dispatchEvent(new CustomEvent('open-cookie-settings'));
  };

  return (
    <footer className={`footer ${className}`}>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-info">
            <div className="footer-logo">
              <span className="logo-text">Yash Haldiya</span>
            </div>
            <p className="footer-description">
              AI Engineer & Software Developer building scalable web applications and intuitive interfaces.
            </p>
            <p className="footer-description" style={{ marginTop: '0.5rem', fontSize: '0.85rem' }}>
              📍 <strong>Address:</strong> {VERIFIED_ADDRESS}
            </p>
          </div>

          <div className="link-group">
            <h4>Navigation</h4>
            <a href="/#home">Home</a>
            <a href="/#about">About</a>
            <a href="/#projects">Projects</a>
            <a href="/#experience">Experience</a>
            <a href="/#achievements">Achievements</a>
          </div>

          <div className="link-group">
            <h4>Legal & DPDP</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms & Conditions</Link>
            <button
              type="button"
              onClick={handleOpenCookieSettings}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                color: 'var(--text-secondary)',
                fontSize: '0.9rem',
                fontFamily: 'inherit',
                cursor: 'pointer',
                textAlign: 'left',
                display: 'block',
                marginBottom: '0.5rem',
              }}
            >
              Cookie Settings
            </button>
          </div>

          <div className="link-group">
            <h4>Connect</h4>
            <Link to="/contact">Contact Page</Link>
            <a href="https://github.com/yashasvi9199" target="_blank" rel="noopener noreferrer">
              GitHub
            </a>
            <a href="mailto:yashaldiya@gmail.com">Email</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Yash Haldiya. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

